import { render, staticRenderFns } from "./policies-dialog-tab.vue?vue&type=template&id=10d2f587&scoped=true&"
import script from "./policies-dialog-tab.vue?vue&type=script&lang=ts&"
export * from "./policies-dialog-tab.vue?vue&type=script&lang=ts&"
import style0 from "./policies-dialog-tab.vue?vue&type=style&index=0&id=10d2f587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d2f587",
  null
  
)

export default component.exports